import axios from 'axios';

const API_URL = 'https://api.paragaia.tn/products';

export const getPromoProducts = () => {
  return axios.get(`${API_URL}/promo`);
};

export const getNonPromoProducts = () => {
  return axios.get(`${API_URL}/non-promo`);
};

export const getProductById = (id, promo) => {
  return axios.get(`${API_URL}/${id}`, {
    params: promo ? { promo } : {},
  });
};

